import { render, staticRenderFns } from "./SwipeScreen.vue?vue&type=template&id=caa3380c"
import script from "./SwipeScreen.vue?vue&type=script&lang=js"
export * from "./SwipeScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports